
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppSelect } from '@/components';
import { useTransactionList } from '@/modules/transaction/text/model/list';
import { ROUTE_NAME_TRANSACTION } from '@/modules/transaction/router';
import { TableColumnType, TableConfig } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_TRANSACTION.TEXT.INDEX,
    components: { AppTable, AppCard, AppFormRow, AppSelect },
    setup() {
        const { list, total, query, fetchList, localeSupportedOptions } = useTransactionList();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Code', key: 'type' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Content', key: 'content' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-edit',
                        theme: 'info',
                        tooltip: 'Edit',
                        to: {
                            name: ROUTE_NAME_TRANSACTION.TEXT.EDIT,
                            params: { code: row.type, locale: query.locale }
                        }
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { query, list, total, table, fetchList, localeSupportedOptions };
    }
});
